module.exports = __webpack_public_path__ + "img/battletrip_carousel.4c45f7e9.jpg";